import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { TRACKING } from "@/config/tracking";
import { initContactClickTracking } from "@/lib/ads";

const anyTracking = Boolean(TRACKING.GTM_ID || TRACKING.GA4_ID || TRACKING.CLARITY_ID || TRACKING.META_PIXEL_ID || TRACKING.GOOGLE_ADS_ID);

const gtag = function () {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
};

const grantConsent = () => {
  gtag("consent", "update", {
    analytics_storage: "granted",
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
  });
  const gtagIds = [];
  if (TRACKING.GA4_ID && TRACKING.GA4_VIA === "direct") gtagIds.push(TRACKING.GA4_ID);
  if (TRACKING.GOOGLE_ADS_ID) gtagIds.push(TRACKING.GOOGLE_ADS_ID);
  if (gtagIds.length && !window.__gtagLoaded) {
    window.__gtagLoaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gtagIds[0])}`;
    document.head.appendChild(s);
    window.gtag = function () { (window.dataLayer = window.dataLayer || []).push(arguments); };
    window.gtag("js", new Date());
    gtagIds.forEach((id) => window.gtag("config", id));
  }
  if (TRACKING.CLARITY_ID && !window.clarity) {
    ((c, l, a, r, i) => {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      const t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      const y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", TRACKING.CLARITY_ID);
  }
  if (TRACKING.META_PIXEL_ID && !window.fbq) {
    ((f, b, e, v, n, t, s) => {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", TRACKING.META_PIXEL_ID);
    window.fbq("track", "PageView");
  }
};

export const CookieConsent = () => {
  const [choice, setChoice] = useState(() => {
    try { return localStorage.getItem("empire_cookie_consent"); } catch { return null; }
  });

  useEffect(() => {
    initContactClickTracking();
    if (choice === "accepted") grantConsent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const decide = (v) => {
    try { localStorage.setItem("empire_cookie_consent", v); } catch { /* private mode */ }
    setChoice(v);
    if (v === "accepted") grantConsent();
  };

  return (
    <>
      <Helmet>
        {TRACKING.GSC_VERIFICATION ? <meta name="google-site-verification" content={TRACKING.GSC_VERIFICATION} /> : null}
        {TRACKING.BING_VERIFICATION ? <meta name="msvalidate.01" content={TRACKING.BING_VERIFICATION} /> : null}
      </Helmet>
      {TRACKING.GTM_ID && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${TRACKING.GTM_ID}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
            title="gtm"
          />
        </noscript>
      )}
      {anyTracking && !choice && (
        <div
          className="fixed bottom-0 inset-x-0 z-[90] bg-white border-t px-5 py-4"
          style={{ borderColor: "#E3E8ED", boxShadow: "0 -4px 16px rgba(10,18,31,0.08)" }}
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookie consent"
        >
          <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center gap-3">
            <p className="flex-1 text-sm" style={{ color: "#16202B" }}>
              We use cookies to measure how the site is used and to improve it. Accept to allow analytics and advertising cookies, or reject non-essential cookies.
            </p>
            <div className="flex gap-2 shrink-0">
              <button
                onClick={() => decide("rejected")}
                className="px-4 py-2.5 border text-sm font-bold"
                style={{ borderColor: "#16202B", color: "#16202B", borderRadius: 4 }}
                data-testid="cookie-reject-btn"
              >
                Reject non-essential
              </button>
              <button
                onClick={() => decide("accepted")}
                className="px-5 py-2.5 text-white text-sm font-bold"
                style={{ backgroundColor: "#215389", borderRadius: 4 }}
                data-testid="cookie-accept-btn"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
